import { render, staticRenderFns } from "./One.vue?vue&type=template&id=1c4bdf49&scoped=true"
import script from "./One.vue?vue&type=script&lang=js"
export * from "./One.vue?vue&type=script&lang=js"
import style0 from "./One.vue?vue&type=style&index=0&id=1c4bdf49&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4bdf49",
  null
  
)

export default component.exports